import { ObjetKForm, requiredRule, combineRules, enumValue } from '@siclop/kstone-vue'
import { ProjectStatus } from '../enums'
import { DisplayUnit } from '@/modules/estimation/enums'
import type { Project } from '../models/Project'

export class ProjectForm extends ObjetKForm {
  code: string = ''
  name: string = ''
  description: string = ''
  customerId: number = 0
  projectTypeId: number = 0
  projectState: ProjectStatus = ProjectStatus.Draft
  startDate?: string
  plannedEndDate?: string
  actualEndDate?: string
  estimatedCost: number = 0
  actualCost: number = 0
  gitLabProjectId?: number
  gitLabUrl: string = ''
  notes: string = ''
  defaultDisplayUnit: DisplayUnit = DisplayUnit.Hours

  static validationRules = {
    name: combineRules(requiredRule('Le nom est obligatoire')),
    customerId: combineRules(requiredRule('Le client est obligatoire')),
    projectTypeId: combineRules(requiredRule('Le type de projet est obligatoire'))
  }

  // Formulaire ou modèle (dates en Date ou en chaîne) : createKsStore construit le formulaire depuis le modèle
  constructor(data?: Partial<ProjectForm> | Partial<Project>) {
    super(data)
    if (data) {
      this.code = data.code ?? ''
      this.name = data.name ?? ''
      this.description = data.description ?? ''
      this.customerId = data.customerId ?? 0
      this.projectTypeId = data.projectTypeId ?? 0
      this.projectState = enumValue(ProjectStatus, data.projectState, ProjectStatus.Draft)
      this.startDate = ProjectForm.toDateString(data.startDate)
      this.plannedEndDate = ProjectForm.toDateString(data.plannedEndDate)
      this.actualEndDate = ProjectForm.toDateString(data.actualEndDate)
      this.estimatedCost = data.estimatedCost ?? 0
      this.actualCost = data.actualCost ?? 0
      this.gitLabProjectId = data.gitLabProjectId
      this.gitLabUrl = data.gitLabUrl ?? ''
      this.notes = data.notes ?? ''
      this.defaultDisplayUnit = enumValue(DisplayUnit, data.defaultDisplayUnit, DisplayUnit.Hours)
    }
  }

  /**
   * Convert a Date or date string to "YYYY-MM-DD" format for el-date-picker compatibility.
   */
  private static toDateString(date?: Date | string): string | undefined {
    if (!date) return undefined
    if (date instanceof Date) return date.toISOString().substring(0, 10)
    // Already a string: extract YYYY-MM-DD part
    return String(date).substring(0, 10)
  }

  toJSON() {
    return {
      id: this.id,
      code: this.code,
      name: this.name,
      description: this.description || null,
      customerId: this.customerId,
      projectTypeId: this.projectTypeId,
      projectState: this.projectState,
      startDate: this.startDate || null,
      plannedEndDate: this.plannedEndDate || null,
      actualEndDate: this.actualEndDate || null,
      estimatedCost: this.estimatedCost,
      actualCost: this.actualCost,
      gitLabProjectId: this.gitLabProjectId ?? null,
      gitLabUrl: this.gitLabUrl || null,
      notes: this.notes || null,
      defaultDisplayUnit: this.defaultDisplayUnit
    }
  }
}
